<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wBjhf2/tc-custom/9781781268346.jpg?1699127791339" alt="This image is the cover for the book Pastels for the Absolute Beginner, Absolute Beginner Craft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pastels for the Absolute Beginner, Absolute Beginner Craft
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover the limitless possibilities of pastels with this beginner’s guide to creating modern, lively, and colorful pastel artwork.</b><br/><br/>Artist and teacher Rebecca de Mendoça offers beginners a complete course in using pastels. Step-by-step exercises and longer projects help you to build the essential skills you need to paint a range of subjects, including landscapes, still life, portraits, and animals. Vital drawing techniques are explained and demonstrated, along with easy-to-follow explanations of color theory, composition, and the pastels themselves.<br/><br/>This volume includes techniques for using both hard and soft pastels, eight skill-building projects, and a wealth of finished artwork to provide ideas and inspiration.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca de Mendonça
      </h2>
      
      <p class="authorDescription body article">Based near Exeter in Devon, Rebecca de Mendonça paints, teaches and writes. Her dynamic pastels capture the movement and atmosphere of subjects ranging from equestrian and landscape to figures and architecture. After graduating in Theatre Design, Rebecca's early career was in theatre and interior design in London. She undertook portrait commissions of West End actors and dancers in English National Ballet. She is an Associate Member of the Society of Equestrian Artists, currently focusing her paintings on people working with horses, and moorland ponies. Rebecca has exhibited at the Mall Galleries in London with the Pastel Society and also as a finalist in the Artists of the Year Exhibition, 2019. Rebecca co-founded The New Pastel School in 2013.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Search Press Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d15f48c